/** Smart price label printing (FR / AR) */
export const priceLabelsFr = {
  printAction: 'Imprimer les étiquettes prix',
  modalTitle: 'Étiquettes prix',
  previewTitle: 'Aperçu des étiquettes',
  selectProductsHint: 'Sélectionnez au moins un produit',
  noEligibleLots: 'Aucun lot éligible avec prix de vente pour la sélection',
  productName: 'Produit',
  sku: 'SKU',
  sellingPrice: 'Prix de vente',
  quantity: 'Quantité',
  labelsCount: 'étiquettes',
  quantityLabels: 'Quantité: {{count}} étiquettes',
  totalLabels: 'Total étiquettes: {{count}}',
  selectPrice: 'Inclure',
  print: 'Imprimer',
  cancel: 'Annuler',
  printing: 'Impression…',
  printSuccess: '{{count}} étiquette(s) envoyée(s) à l’imprimante',
  printFailed: 'Échec de l’impression des étiquettes',
  reprint: 'Réimprimer',
  reprintPrevious: 'Réimprimer les précédentes',
  recentJobs: 'Historique d’impression',
  noHistory: 'Aucun historique d’impression',
  resetQuantity: 'Réinitialiser',
  selectedCount: '{{count}} produit(s) sélectionné(s)',
  clearSelection: 'Vider la sélection',
  selectAllPage: 'Page',
  sheetFormat: 'Style 403 — 29×20 mm · 4×10 (40/feuille)',
  sheetPreview: 'Aperçu feuille Style 403',
  sheetMoreLabels: '+{{count}} étiquette(s) sur les feuilles suivantes à l’impression',
  confirmPrintTitle: 'Confirmer l\'impression',
  confirmPrintMessage:
    'Imprimante : {{printer}}\n{{count}} étiquette(s) — feuille Style 403 (29×20 mm)\n\nChargez une feuille Style 403 dans l\'imprimante.\nÉchelle 100 % — sans « Ajuster à la page ».\n\nLancer l\'impression ?',
  confirmPrintBrowserMessage:
    'Une fenêtre d\'impression du navigateur s\'ouvrira.\n{{count}} étiquette(s) — Style 403\n\nContinuer ?',
  confirmPrintBtn: 'Imprimer maintenant',
  unknownPrinter: 'Imprimante par défaut',
  checkingPrinter: 'Vérification imprimante…'
};

export const priceLabelsAr = {
  printAction: 'طباعة ملصقات الأسعار',
  modalTitle: 'ملصقات الأسعار',
  previewTitle: 'معاينة الملصقات',
  selectProductsHint: 'حدد منتجًا واحدًا على الأقل',
  noEligibleLots: 'لا توجد دفعات مؤهلة بسعر بيع للاختيار الحالي',
  productName: 'المنتج',
  sku: 'SKU',
  sellingPrice: 'سعر البيع',
  quantity: 'الكمية',
  labelsCount: 'ملصقات',
  quantityLabels: 'الكمية: {{count}} ملصق',
  totalLabels: 'إجمالي الملصقات: {{count}}',
  selectPrice: 'تضمين',
  print: 'طباعة',
  cancel: 'إلغاء',
  printing: 'جاري الطباعة…',
  printSuccess: 'تم إرسال {{count}} ملصق إلى الطابعة',
  printFailed: 'فشل طباعة الملصقات',
  reprint: 'إعادة الطباعة',
  reprintPrevious: 'إعادة طباعة السابقة',
  recentJobs: 'سجل الطباعة',
  noHistory: 'لا يوجد سجل طباعة',
  resetQuantity: 'إعادة التعيين',
  selectedCount: '{{count}} منتج محدد',
  clearSelection: 'مسح التحديد',
  selectAllPage: 'الصفحة',
  sheetFormat: 'Style 403 — 29×20 مم · 4×10 (40/ورقة)',
  sheetPreview: 'معاينة ورقة Style 403',
  sheetMoreLabels: '+{{count}} ملصق في الأوراق التالية عند الطباعة',
  confirmPrintTitle: 'تأكيد الطباعة',
  confirmPrintMessage:
    'الطابعة: {{printer}}\n{{count}} ملصق — ورقة Style 403 (29×20 مم)\n\nأدخل ورقة Style 403 في الطابعة.\nمقياس 100٪ — بدون «ملاءمة الصفحة».\n\nبدء الطباعة؟',
  confirmPrintBrowserMessage:
    'ستفتح نافذة طباعة المتصفح.\n{{count}} ملصق — Style 403\n\nمتابعة؟',
  confirmPrintBtn: 'طباعة الآن',
  unknownPrinter: 'الطابعة الافتراضية',
  checkingPrinter: 'جاري التحقق من الطابعة…'
};
